import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { AlgoliaCardIndexesNames } from '@sorare/core/src/contexts/config';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import idFromObject from '@sorare/core/src/gql/idFromObject';

import useDefaultFilters from '@sorare/marketplace/src/hooks/useDefaultFilters';
import AdvancedCardSearch, {
  FullProps,
} from '@sorare/marketplace/src/searchCards/AdvancedCardSearch';

import { Cards_user } from './__generated__/index.graphql';

const sorts: AlgoliaCardIndexesNames = [
  'Cards New',
  'Cards Highest Average Score',
  'Cards Highest Price',
  'Cards Lowest Price',
];

interface Props {
  sport: Sport;
  user: {
    id: string;
    slug: string;
  };
  galleryFilters: FullProps['cardFilters'];
  PlayerDetailsComponent: FullProps['PlayerDetailsComponent'];
}

export const Cards = ({
  sport,
  user,
  galleryFilters,
  PlayerDetailsComponent,
}: Props) => {
  const { currentUser } = useCurrentUserContext();

  const filters = useDefaultFilters({ userId: idFromObject(user.id) });

  return (
    <AdvancedCardSearch
      defaultSort="Cards New"
      sport={sport}
      sorts={sorts}
      cardFilters={galleryFilters}
      analyticsTags={['Gallery', sport === Sport.NBA ? 'NBA' : 'Baseball']}
      galleryOwnerSlug={user.slug}
      includeCommonCards={!currentUser?.userSettings?.hideCommonCards}
      hideOwner
      defaultFilters={filters}
      PlayerDetailsComponent={PlayerDetailsComponent}
    />
  );
};

Cards.fragments = {
  user: gql`
    fragment Cards_user on User {
      id
      slug
    }
  ` as TypedDocumentNode<Cards_user>,
};
